import { buildCatalogFingerprint } from "@/domain/cart/cart-validity.catalog";
import type { MenuCatalogItem, MenuCatalogSnapshot } from "@/domain/cart/cart-validity.types";
import type { MenuItemInterface } from "@/models/menu-item";

export type BuildMenuCatalogSnapshotInput = {
  items: MenuItemInterface[];
  restaurantId: string;
  restaurantAvailable?: boolean;
  loaded?: boolean;
  fetchedAt?: string;
};

/** Maps a Redux menu row into a validity catalog item. */
export function mapMenuItemToCatalogItem(item: MenuItemInterface): MenuCatalogItem {
  return {
    menu_item_id: String(item.menu_item_id),
    restaurant_id: String(item.restaurant_id),
    item_name: item.item_name,
    category: item.category,
    item_price: item.item_price,
    is_available: item.is_available !== false,
    menu_version: Math.max(0, Math.floor(Number(item.menu_version) || 0)),
    is_deleted: item.is_deleted === true,
    modifier_groups: item.modifier_groups,
    components: item.components,
  };
}

/**
 * Builds a {@link MenuCatalogSnapshot} once per catalog load.
 * Fingerprint is computed here only — consumers must not re-hash ad hoc.
 */
export function buildMenuCatalogSnapshot(input: BuildMenuCatalogSnapshotInput): MenuCatalogSnapshot {
  const catalogItems = input.items.map(mapMenuItemToCatalogItem);
  const loaded = input.loaded ?? catalogItems.length > 0;
  const restaurantAvailable = input.restaurantAvailable ?? loaded;

  return {
    loaded,
    restaurantId: input.restaurantId,
    restaurantAvailable,
    items: catalogItems,
    fingerprint: buildCatalogFingerprint(catalogItems),
    fetchedAt: input.fetchedAt ?? new Date().toISOString(),
  };
}
